import React from "react"
import { withRouteData, Link } from "react-static"
import Map from "components/Map"
import Icon from "components/Icon"
import "./styles.css"

export default withRouteData(({ site }) => {
	return (
		<div id="site" className="grid-content">
			<div className="card">
				<h1>{site.name}</h1>
				<div className="meta">
					<div>
						<i uk-icon="location" /> {site.site_type}
					</div>
					<div>
						<i uk-icon="calendar" /> Created at{" "}
						{new Date(site.date).toLocaleDateString()}
					</div>
				</div>
			</div>

			<div id="site-content">
				<div id="site-data" className="card">
					<h3 className="uk-card-title">Description</h3>
					<p className="uk-text-small" id="description">
						{site.description}
					</p>
				</div>

				<Map
					id="site-map"
					minHeight="500px"
					zoom="13"
					title={site.name}
					point={site.coordinates}
				/>
			</div>

			<div id="site-actions" className="card narrow">
				<Link to="/sites" className="button">
					<Icon name="arrow-left" />
					Back
				</Link>
			</div>
		</div>
	)
})



// WEBPACK FOOTER //
// /home/christian/git/pwa-crc806db/src/containers/Site/index.js